/**
 * components/landing/ai-platform/AIPlatformPage.jsx — Phase 4 orchestrator.
 *
 * Composes the 12-section AI Platform narrative:
 *
 *   4.1  Hero               — introduce the AI
 *   4.2  Vision             — our philosophy
 *   4.3  Architecture       — the 8-layer AI stack
 *   4.4  AI Mentor          — deep dive
 *   4.5  Knowledge Base     — RAG anatomy + sources
 *   4.6  Prompt Intelligence — orchestration
 *   4.7  Automation         — workflow AI
 *   4.8  Across the Platform — AI in every module
 *   4.9  Enterprise AI      — quality + governance
 *   4.10 Use Cases          — practical scenarios
 *   4.11 FAQ                — practical answers
 *   4.12 Final CTA          — close the loop
 */

import SiteFrame from '@/components/landing/SiteFrame'
import Hero              from './sections/Hero'
import Vision            from './sections/Vision'
import Architecture      from './sections/Architecture'
import AIMentor          from './sections/AIMentor'
import KnowledgeBase     from './sections/KnowledgeBase'
import PromptIntelligence from './sections/PromptIntelligence'
import Automation        from './sections/Automation'
import AIAcrossPlatform  from './sections/AIAcrossPlatform'
import EnterpriseAI      from './sections/EnterpriseAI'
import UseCases          from './sections/UseCases'
import FAQ               from './sections/FAQ'
import FinalCTA          from './sections/FinalCTA'

const AIPlatformPage = () => (
  <SiteFrame hideFooterCta={true}>
    <Hero />               {/* 4.1  */}
    <Vision />             {/* 4.2  */}
    <Architecture />       {/* 4.3  */}
    <AIMentor />           {/* 4.4  */}
    <KnowledgeBase />      {/* 4.5  */}
    <PromptIntelligence /> {/* 4.6  */}
    <Automation />         {/* 4.7  */}
    <AIAcrossPlatform />   {/* 4.8  */}
    <EnterpriseAI />       {/* 4.9  */}
    <UseCases />           {/* 4.10 */}
    <FAQ />                {/* 4.11 */}
    <FinalCTA />           {/* 4.12 */}
  </SiteFrame>
)

export default AIPlatformPage
